export class EligibilityCheckPatientScheduleWebhookStruct {
    public userCompleteName: string;
    public userBirthDate: Date;
    public planName: string;
    public nameHealthcareAgreement: string;
    public idMedicalSpecialtyFederalCouncilMedicine: number;
    public healthcareAgreementCardNumber: string;
    public healthcareAgreementExpirationDate: Date;
}